import React, { Component } from 'react';
import { ReactComponent as IconLoading } from '../../media/animated_icons/loading.svg';


export default class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
        };
    }


    render() {
        return (
            <div className="overlay">
                <div className="overlay__loading">
                    <IconLoading className="overlay__loading__icon" />
                    <div className="overlay__loading__textbox">
                        Loading ...
                    </div>
                </div>
            </div>
        )
    }
}
